import { render, staticRenderFns } from "./TipoPuestos.vue?vue&type=template&id=fa7a8ff0"
import script from "./TipoPuestos.vue?vue&type=script&lang=js"
export * from "./TipoPuestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports